import React, { useState, useEffect, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import GalleryModal from './Gallery/GalleryModal';
import FormDetails from "./Forms/Details";
import FormAddress from "./Forms/Address";
import FormImages from "./Forms/Images";
import FormVideos from "./Forms/Videos";
import FormSocials from "./Forms/Socials";
import FormContacts from "./Forms/ContactFields";
import FormAmenities from "./Forms/Amenities";
import FormHours from "./Forms/Hours";
import FormFaqs from "./Forms/Faqs";
import FormMenus from "./Forms/Menus";
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@uppy/webcam/dist/style.min.css';
import FormOwner from "./Forms/Owner";

const listingSchema = Yup.object().shape({
  name: Yup.string().required("Required"),
  categories: Yup.array().required("Required"),
  description: Yup.string().required("Required"),
  email: Yup.string().transform((value) => typeof value === 'string' ? value.trim() : value).nullable().email()
})
const ListingEdit = (props) => {

  const { listing, submitUrl, userRole } = props;
  const isOwner = (userRole !== 'admin');
  const [isLoading, setIsLoading] = useState(false)
  const [isFixed, setIsFixed] = useState(!isOwner);
  const handleSave = (data) => {
    setIsLoading(true);
    fetch(submitUrl, {
      method: 'PUT',
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          ?.content,
      },
      body: JSON.stringify({ listing: data })
    }).then((resp) => {
      return resp.json();
    }).then((resp) => {
      console.log('resp', resp);
      setIsLoading(false);
      window.location.reload();
    }).catch((error) => {
      console.log('error', error);
      setIsLoading(false);
    })
  }

  useEffect(() => {
    const handleScroll = () => {
      const scrollOffset = window.scrollY;
      const shouldFixFooter = scrollOffset >= 600;
      setIsFixed(shouldFixFooter);
    };

    window.addEventListener('scroll', handleScroll);

    // Clean up the event listener when the component is unmounted
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };

  }, []);
  return (
    <React.Fragment>
      <Formik
        initialValues={{ ...listing, email: listing.email ?? '' }}
        onSubmit={async values => {
          handleSave(values);
        }}
        validationSchema={listingSchema}
      >
        {props => {
          const {
            values,
            touched,
            errors,
            dirty,
            isSubmitting,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            submitCount
          } = props;
          const autoFocus = () => {
            console.log('errors', errors)
          }
          return (
            <form onSubmit={e => { autoFocus(errors); return handleSubmit(e) }}>
              {submitCount > 0 && Object.keys(errors).length > 0 && (
                <div role="alert" className="alert alert-danger">
                  Please check: {Object.keys(errors).join(', ')}.
                </div>
              )}
              <FormDetails {...props} />
              <FormAddress {...props} userRole={userRole} />
              <FormImages {...props} />
              <FormVideos {...props} />
              <FormSocials {...props} />
              <FormContacts {...props} />
              {/* <FormAmenities {...props}/> */}
              <FormHours {...props} />
              <FormMenus {...props} />
              {
                !isOwner && <FormOwner {...props} />
              }
              <br />
              <div className={`form-action ${(!isOwner && isFixed) ? 'is-fixed' : ''}`}>
                <button type="submit" className="btn btn-primary text-center" disabled={isSubmitting || isLoading}>
                  <i className="fa fa-arrow-circle-right"></i> Save &amp; Preview
                </button>
              </div>

            </form>
          );
        }}
      </Formik>
      <GalleryModal
      // isOpen={true}
      />
    </React.Fragment>
  );
};

export default ListingEdit;
